import request from './interceptor'

/**
 * 获取投递列表
 * @param {Object} params - 查询参数
 * @param {number} [params.page=1] - 页码
 * @param {number} [params.page_size=10] - 每页条数
 * @param {string} [params.start_time] - 开始时间
 * @param {string} [params.end_time] - 结束时间
 * @param {number} [params.status] - 投递状态
 * @param {string} [params.device_code] - 设备编号
 * @param {string} [params.device_name] - 容器名称
 * @param {string} [params.openid] - 用户openid
 * @param {string} [params.deliveryNo] - 投递单号
 */
export function getDeliveries(params = {}) {
  // 默认参数
  const defaultParams = {
    page: 1,
    page_size: 1
  }
  
  // 合并默认参数和传入参数
  const finalParams = { ...defaultParams, ...params }
  
  return request({
    url: '/v1/deliveries',
    method: 'get',
    params: finalParams
  })
}

/**
 * 获取投递记录详情
 * @param {number} id - 投递记录ID
 * @returns {Promise} - 返回投递记录详情
 */
export function getDeliveryDetail(id) {
  return request({
    url: `/v1/deliveries/${id}`,
    method: 'get'
  })
}


/**
 * 更新投递状态
 * @param {number} id - 投递记录ID
 * @param {Object} data - 更新数据
 * @param {number} data.status - 投递状态
 */
export function updateDeliveryStatus(id, data) {
  return request({
    url: `/v1/deliveries/${id}/status`,
    method: 'put',
    data: data
  })
}

// 新增：提交违投判定
export function markDeliveryViolation(data) {
  return request({
    url: '/v1/deliveries/violation',
    method: 'post',
    data
  })
}

// 调整订单重量（扣重/补重）
export function adjustDeliveryWeight(data) {
  return request({
    url: '/v1/deliveries/adjust-weight',
    method: 'post',
    data
  })
}

export function reportDeliveryViolation(data) {
  return request({
    url: '/v1/deliveries/violation',
    method: 'post',
    data
  })
}

export function reverseDeliveryViolation(data) {
  return request({
    url: '/v1/deliveries/reverse',
    method: 'post',
    data
  })
}
